// TODO: replace when SSM params are available
export const snowplowServerUrl = () => {
  switch (process.env.ENV) {
    case "qa":
    case "qa-zion":
    case "qa-arches":
    case "qa-bryce":
    case "stage":
      return "com-ltk-qa1.collector.snplow.net";
    case "prod":
      return "com-ltk-prod1.collector.snplow.net";
    default:
      return "http://localhost:9090";
  }
};

export const VISIBLE_THRESHOLD_PERCENT = 0.5;
